// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_1hxXxS-7uTOg2qn6EPPgRj","spaceLeft":"_38FHv7UvtzQQwyxYGm2vWJ","spaceBoth":"_1cvQWE5Hc9b7Zg49xAAdtu","spaceRight":"_5r6fSb-K4hXKpjzAV96qi","buy":"_35KF8cKcJ_zwgjH480pwJZ","sell":"_3_7Hk-v8EGft727cFl1HIa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisTradeType.scss
// module id = 1207
// module chunks = 0